function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { autoType, csvParse, csvParseRows, tsvParse, tsvParseRows } from "d3-dsv";
import { arrow4, arrow9, arrow11, jszip, exceljs } from "./dependencies.js";
import { cdn, requireDefault } from "./require.js";
import { SQLiteDatabaseClient } from "./sqlite.js";
import { inferSchema, coerceRow } from "./table.js";
import { Workbook } from "./xlsx.js";

function remote_fetch(_x) {
  return _remote_fetch.apply(this, arguments);
}

function _remote_fetch() {
  _remote_fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(file) {
    var response;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.t0 = fetch;
            _context21.next = 3;
            return file.url();

          case 3:
            _context21.t1 = _context21.sent;
            _context21.next = 6;
            return (0, _context21.t0)(_context21.t1);

          case 6:
            response = _context21.sent;

            if (response.ok) {
              _context21.next = 9;
              break;
            }

            throw new Error("Unable to load file: ".concat(file.name));

          case 9:
            return _context21.abrupt("return", response);

          case 10:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _remote_fetch.apply(this, arguments);
}

export function enforceSchema(source, schema) {
  var types = new Map(schema.map(function (_ref) {
    var name = _ref.name,
        type = _ref.type;
    return [name, type];
  }));
  return Object.assign(source.map(function (d) {
    return coerceRow(d, types, schema);
  }), {
    schema: schema
  });
}

function dsv(_x2, _x3) {
  return _dsv.apply(this, arguments);
}

function _dsv() {
  _dsv = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(file, delimiter) {
    var _ref3,
        _ref3$array,
        array,
        _ref3$typed,
        typed,
        text,
        parse,
        source,
        _args22 = arguments;

    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _ref3 = _args22.length > 2 && _args22[2] !== undefined ? _args22[2] : {}, _ref3$array = _ref3.array, array = _ref3$array === void 0 ? false : _ref3$array, _ref3$typed = _ref3.typed, typed = _ref3$typed === void 0 ? false : _ref3$typed;
            _context22.next = 3;
            return file.text();

          case 3:
            text = _context22.sent;
            parse = delimiter === "\t" ? array ? tsvParseRows : tsvParse : array ? csvParseRows : csvParse;

            if (!(typed === "auto" && !array)) {
              _context22.next = 8;
              break;
            }

            source = parse(text);
            return _context22.abrupt("return", enforceSchema(source, inferSchema(source, source.columns)));

          case 8:
            return _context22.abrupt("return", parse(text, typed && autoType));

          case 9:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _dsv.apply(this, arguments);
}

export var AbstractFile = /*#__PURE__*/function () {
  function AbstractFile(name, mimeType) {
    _classCallCheck(this, AbstractFile);

    Object.defineProperty(this, "name", {
      value: name,
      enumerable: true
    });
    if (mimeType !== undefined) Object.defineProperty(this, "mimeType", {
      value: mimeType + "",
      enumerable: true
    });
  }

  _createClass(AbstractFile, [{
    key: "blob",
    value: function () {
      var _blob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return remote_fetch(this);

              case 2:
                return _context.abrupt("return", _context.sent.blob());

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function blob() {
        return _blob.apply(this, arguments);
      }

      return blob;
    }()
  }, {
    key: "arrayBuffer",
    value: function () {
      var _arrayBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return remote_fetch(this);

              case 2:
                return _context2.abrupt("return", _context2.sent.arrayBuffer());

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function arrayBuffer() {
        return _arrayBuffer.apply(this, arguments);
      }

      return arrayBuffer;
    }()
  }, {
    key: "text",
    value: function () {
      var _text = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return remote_fetch(this);

              case 2:
                return _context3.abrupt("return", _context3.sent.text());

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function text() {
        return _text.apply(this, arguments);
      }

      return text;
    }()
  }, {
    key: "json",
    value: function () {
      var _json = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return remote_fetch(this);

              case 2:
                return _context4.abrupt("return", _context4.sent.json());

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function json() {
        return _json.apply(this, arguments);
      }

      return json;
    }()
  }, {
    key: "stream",
    value: function () {
      var _stream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return remote_fetch(this);

              case 2:
                return _context5.abrupt("return", _context5.sent.body);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function stream() {
        return _stream.apply(this, arguments);
      }

      return stream;
    }()
  }, {
    key: "csv",
    value: function () {
      var _csv = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(options) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", dsv(this, ",", options));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function csv(_x4) {
        return _csv.apply(this, arguments);
      }

      return csv;
    }()
  }, {
    key: "tsv",
    value: function () {
      var _tsv = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(options) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", dsv(this, "\t", options));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function tsv(_x5) {
        return _tsv.apply(this, arguments);
      }

      return tsv;
    }()
  }, {
    key: "image",
    value: function () {
      var _image = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(props) {
        var _this = this;

        var url;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.url();

              case 2:
                url = _context8.sent;
                return _context8.abrupt("return", new Promise(function (resolve, reject) {
                  var i = new Image();

                  if (new URL(url, document.baseURI).origin !== new URL(location).origin) {
                    i.crossOrigin = "anonymous";
                  }

                  Object.assign(i, props);

                  i.onload = function () {
                    return resolve(i);
                  };

                  i.onerror = function () {
                    return reject(new Error("Unable to load file: ".concat(_this.name)));
                  };

                  i.src = url;
                }));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function image(_x6) {
        return _image.apply(this, arguments);
      }

      return image;
    }()
  }, {
    key: "arrow",
    value: function () {
      var _arrow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _ref2,
            _ref2$version,
            version,
            _yield$Promise$all,
            _yield$Promise$all2,
            Arrow,
            response,
            _yield$Promise$all3,
            _yield$Promise$all4,
            _Arrow,
            _response,
            _yield$Promise$all5,
            _yield$Promise$all6,
            _Arrow2,
            _response2,
            _args9 = arguments;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _ref2 = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {}, _ref2$version = _ref2.version, version = _ref2$version === void 0 ? 4 : _ref2$version;
                _context9.t0 = version;
                _context9.next = _context9.t0 === 4 ? 4 : _context9.t0 === 9 ? 11 : _context9.t0 === 11 ? 18 : 25;
                break;

              case 4:
                _context9.next = 6;
                return Promise.all([requireDefault(arrow4.resolve()), remote_fetch(this)]);

              case 6:
                _yield$Promise$all = _context9.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                Arrow = _yield$Promise$all2[0];
                response = _yield$Promise$all2[1];
                return _context9.abrupt("return", Arrow.Table.from(response));

              case 11:
                _context9.next = 13;
                return Promise.all([import("".concat(cdn).concat(arrow9.resolve())), remote_fetch(this)]);

              case 13:
                _yield$Promise$all3 = _context9.sent;
                _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
                _Arrow = _yield$Promise$all4[0];
                _response = _yield$Promise$all4[1];
                return _context9.abrupt("return", _Arrow.tableFromIPC(_response));

              case 18:
                _context9.next = 20;
                return Promise.all([import("".concat(cdn).concat(arrow11.resolve())), remote_fetch(this)]);

              case 20:
                _yield$Promise$all5 = _context9.sent;
                _yield$Promise$all6 = _slicedToArray(_yield$Promise$all5, 2);
                _Arrow2 = _yield$Promise$all6[0];
                _response2 = _yield$Promise$all6[1];
                return _context9.abrupt("return", _Arrow2.tableFromIPC(_response2));

              case 25:
                throw new Error("unsupported arrow version: ".concat(version));

              case 26:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function arrow() {
        return _arrow.apply(this, arguments);
      }

      return arrow;
    }()
  }, {
    key: "sqlite",
    value: function () {
      var _sqlite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", SQLiteDatabaseClient.open(remote_fetch(this)));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function sqlite() {
        return _sqlite.apply(this, arguments);
      }

      return sqlite;
    }()
  }, {
    key: "zip",
    value: function () {
      var _zip = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _yield$Promise$all7, _yield$Promise$all8, JSZip, buffer;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return Promise.all([requireDefault(jszip.resolve()), this.arrayBuffer()]);

              case 2:
                _yield$Promise$all7 = _context11.sent;
                _yield$Promise$all8 = _slicedToArray(_yield$Promise$all7, 2);
                JSZip = _yield$Promise$all8[0];
                buffer = _yield$Promise$all8[1];
                _context11.t0 = ZipArchive;
                _context11.next = 9;
                return JSZip.loadAsync(buffer);

              case 9:
                _context11.t1 = _context11.sent;
                return _context11.abrupt("return", new _context11.t0(_context11.t1));

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function zip() {
        return _zip.apply(this, arguments);
      }

      return zip;
    }()
  }, {
    key: "xml",
    value: function () {
      var _xml = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var mimeType,
            _args12 = arguments;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                mimeType = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : "application/xml";
                _context12.t0 = new DOMParser();
                _context12.next = 4;
                return this.text();

              case 4:
                _context12.t1 = _context12.sent;
                _context12.t2 = mimeType;
                return _context12.abrupt("return", _context12.t0.parseFromString.call(_context12.t0, _context12.t1, _context12.t2));

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function xml() {
        return _xml.apply(this, arguments);
      }

      return xml;
    }()
  }, {
    key: "html",
    value: function () {
      var _html = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", this.xml("text/html"));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function html() {
        return _html.apply(this, arguments);
      }

      return html;
    }()
  }, {
    key: "xlsx",
    value: function () {
      var _xlsx = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var _yield$Promise$all9, _yield$Promise$all10, ExcelJS, buffer;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return Promise.all([requireDefault(exceljs.resolve()), this.arrayBuffer()]);

              case 2:
                _yield$Promise$all9 = _context14.sent;
                _yield$Promise$all10 = _slicedToArray(_yield$Promise$all9, 2);
                ExcelJS = _yield$Promise$all10[0];
                buffer = _yield$Promise$all10[1];
                _context14.t0 = Workbook;
                _context14.next = 9;
                return new ExcelJS.Workbook().xlsx.load(buffer);

              case 9:
                _context14.t1 = _context14.sent;
                return _context14.abrupt("return", new _context14.t0(_context14.t1));

              case 11:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function xlsx() {
        return _xlsx.apply(this, arguments);
      }

      return xlsx;
    }()
  }]);

  return AbstractFile;
}();
export var FileAttachment = /*#__PURE__*/function (_AbstractFile) {
  _inherits(FileAttachment, _AbstractFile);

  var _super = _createSuper(FileAttachment);

  function FileAttachment(url, name, mimeType) {
    var _this2;

    _classCallCheck(this, FileAttachment);

    _this2 = _super.call(this, name, mimeType);
    Object.defineProperty(_assertThisInitialized(_this2), "_url", {
      value: url
    });
    return _this2;
  }

  _createClass(FileAttachment, [{
    key: "url",
    value: function () {
      var _url = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this._url;

              case 2:
                _context15.t0 = _context15.sent;
                return _context15.abrupt("return", _context15.t0 + "");

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function url() {
        return _url.apply(this, arguments);
      }

      return url;
    }()
  }]);

  return FileAttachment;
}(AbstractFile);
export function NoFileAttachments(name) {
  throw new Error("File not found: ".concat(name));
}
export function FileAttachments(resolve) {
  return Object.assign(function (name) {
    var result = resolve(name += "");
    if (result == null) throw new Error("File not found: ".concat(name));

    if (_typeof(result) === "object" && "url" in result) {
      var url = result.url,
          mimeType = result.mimeType;
      return new FileAttachment(url, name, mimeType);
    }

    return new FileAttachment(result, name);
  }, {
    prototype: FileAttachment.prototype
  } // instanceof
  );
}
export var ZipArchive = /*#__PURE__*/function () {
  function ZipArchive(archive) {
    _classCallCheck(this, ZipArchive);

    Object.defineProperty(this, "_", {
      value: archive
    });
    this.filenames = Object.keys(archive.files).filter(function (name) {
      return !archive.files[name].dir;
    });
  }

  _createClass(ZipArchive, [{
    key: "file",
    value: function file(path) {
      var object = this._.file(path += "");

      if (!object || object.dir) throw new Error("file not found: ".concat(path));
      return new ZipArchiveEntry(object);
    }
  }]);

  return ZipArchive;
}();

var ZipArchiveEntry = /*#__PURE__*/function (_AbstractFile2) {
  _inherits(ZipArchiveEntry, _AbstractFile2);

  var _super2 = _createSuper(ZipArchiveEntry);

  function ZipArchiveEntry(object) {
    var _this3;

    _classCallCheck(this, ZipArchiveEntry);

    _this3 = _super2.call(this, object.name);
    Object.defineProperty(_assertThisInitialized(_this3), "_", {
      value: object
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_url", {
      writable: true
    });
    return _this3;
  }

  _createClass(ZipArchiveEntry, [{
    key: "url",
    value: function () {
      var _url2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", this._url || (this._url = this.blob().then(URL.createObjectURL)));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function url() {
        return _url2.apply(this, arguments);
      }

      return url;
    }()
  }, {
    key: "blob",
    value: function () {
      var _blob2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", this._.async("blob"));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function blob() {
        return _blob2.apply(this, arguments);
      }

      return blob;
    }()
  }, {
    key: "arrayBuffer",
    value: function () {
      var _arrayBuffer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", this._.async("arraybuffer"));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function arrayBuffer() {
        return _arrayBuffer2.apply(this, arguments);
      }

      return arrayBuffer;
    }()
  }, {
    key: "text",
    value: function () {
      var _text2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", this._.async("text"));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function text() {
        return _text2.apply(this, arguments);
      }

      return text;
    }()
  }, {
    key: "json",
    value: function () {
      var _json2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.t0 = JSON;
                _context20.next = 3;
                return this.text();

              case 3:
                _context20.t1 = _context20.sent;
                return _context20.abrupt("return", _context20.t0.parse.call(_context20.t0, _context20.t1));

              case 5:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function json() {
        return _json2.apply(this, arguments);
      }

      return json;
    }()
  }]);

  return ZipArchiveEntry;
}(AbstractFile);